import { motion } from 'motion/react';

import { iconsSources } from 'helpers/icons';
import { hideNumber } from 'helpers/titreHelper';

import styles from './Message.module.css';

export const Message = ({
  message,
  authorFontSize,
  currentState,
  winId,
  RND_ONE_WIN,
  RND_WIN,
}) => {
  const errorHandler = (e) => {
    e.target.src = iconsSources[message?.channel];
  };

  const srcAvatar =
    (message?.image !== '1' && message?.image) ||
    iconsSources[message?.channel];
  const reserveBg = `url(${iconsSources[message?.channel]}) center/cover no-repeat`;

  const isWinner = currentState === RND_WIN || currentState === RND_ONE_WIN;
  const isWinMsg = isWinner && winId === message.id;
  const delayMsg = currentState === RND_ONE_WIN ? 1 : 0.5;

  return (
    <div className={styles.wrapper}>
      {message && (
        <motion.div
          initial={{ originX: '35%', opacity: 1 }}
          animate={{
            opacity: isWinner && winId !== message.id ? 0 : 1,
            scale: !isWinner ? 1 : winId !== message.id ? 1 : 1.4,
            originX: '25%',
          }}
          transition={{ duration: 1, delay: delayMsg }}
          className={styles.blockMsg}
        >
          <div className={styles.avatar}>
            <div
              className={styles.avatarBg}
              style={{ background: reserveBg }}
            />
            <motion.img
              initial={{ borderColor: '#fff' }}
              animate={{
                borderColor: isWinMsg
                  ? ['#fff', '#E75A9C', '#0252A9', '#C7003A']
                  : '#fff',
              }}
              transition={{ duration: 0.73, delay: delayMsg }}
              src={srcAvatar}
              alt={message?.author}
              onError={errorHandler}
            />
          </div>
          <motion.div
            initial={{
              backgroundColor: '#fff',
              color: '#00233a',
              borderColor: 'rgba(2, 82, 169, 0.5)',
              boxShadow: 'inset 0 0 0 0.4rem rgba(2, 82, 169, 0.5)',
            }}
            animate={{
              backgroundColor: isWinMsg
                ? ['#fff', '#C7003A', '#fff', '#C7003A']
                : '#fff',
              color: isWinMsg
                ? ['#00233a', '#fff', '#00233a', '#fff']
                : '#00233a',
              borderColor: isWinMsg
                ? 'rgba(255, 255, 255, 0.5)'
                : 'rgba(2, 82, 169, 0.5)',
              boxShadow: isWinMsg
                ? 'inset 0 0 0 0.4rem rgba(255, 255, 255, 0.5)'
                : 'inset 0 0 0 0.4rem rgba(2, 82, 169, 0.5)',
            }}
            transition={{ duration: 0.73, delay: delayMsg }}
            className={styles.nameAuthor}
            style={{ fontSize: `${authorFontSize}rem` }}
          >
            {message?.author || hideNumber(message?.senderNumber)}
          </motion.div>
        </motion.div>
      )}
    </div>
  );
};
